module.exports = __webpack_public_path__ + "img/slika-1.ee2fe709.png";